import App from "@frog/source/models/App.js"
import Stage from "@frog/source/models/Stage.js"
import Dev from "@frog/source/models/admin/Dev.js"

import Objdict from "objdict"

const devSelection = new class DevSelection {
    constructor() {
    }

    placeNewUnit(position) {
        if(Dev.selectedTemplate == undefined) return
        const baseUnit = {
            "position": {
                "x": position.x,
                "y": position.y,
                "z": 1
            },
        }
        const newUnit = Objdict.merge(baseUnit,Dev.selectedTemplate)
        Dev.createNewUnit(newUnit)
    }
}

export default devSelection
